import {Component, Prop, Vue} from 'vue-property-decorator';

export interface IdentityCard {
    identifier: string;
    qrCodeIdentifier: string;
    fullName: string;
    tags: string[]
}

@Component({
})
export default class IdentityCardComponent extends Vue {

    @Prop() public identity!: IdentityCard;
    @Prop() public translations!: { [key: string]: string; };
    @Prop({ default: 'sv-SE' }) public language!: string;

    constructor() {
        super();
    }

    public async openModal(): Promise<void> {

        $(`#IdentityCardModal`).modal('show');
    }

    public get qrCode(): string {

        if (!this.identity.qrCodeIdentifier) {

            return '';
        }

        return `/easyvote-api/qrCode?content=${this.identity.qrCodeIdentifier}`
    }
}
